//@flow
import React from 'react';
import { RichText } from 'prismic-reactjs';
import { PrismicAwardAbout } from '../../types/prismic';
import styles from './grant-about.module.scss';

type Props = PrismicAwardAbout;

const GrantAbout = ({ data }: Props) => {
  const {
    about_header,
    about_description,
    about_header_2,
    about_description_2,
  } = data;

  const has2ndAbout = about_header_2[0];

  return (
    <>
      <section
        className={`
          ${has2ndAbout ? 'bg-salmon' : 'bg-rust'}
          zIndex-0 full-width column center`}
      >
        <article className={`center inner-width inner-width-padding-double`}>
          <div className="text-center">
            <h2 style={{ maxWidth: '100% !important' }}>
              {about_header[0].text}
            </h2>
            <RichText render={about_description} />
          </div>
        </article>
      </section>
      {has2ndAbout && (
        <section className="bg-rust zIndex-0 full-width column center">
          <article className={`center inner-width inner-width-padding-double`}>
            <div className="text-center">
              <h2 className={styles.aboutGrant}>{about_header_2[0].text}</h2>
              <div className={styles.aboutGrantDescription}>
                <RichText render={about_description_2} />
              </div>
            </div>
          </article>
        </section>
      )}
    </>
  );
};

export default GrantAbout;
